module.exports = __webpack_public_path__ + "clothing.svg?2427256a39d1fa4d2ced2942e2a90ad6";


//////////////////
// WEBPACK FOOTER
// ./src/assets/badges/clothing.svg
// module id = 89
// module chunks = 0